import { useEffect, useState } from 'react';
import { PlaycastPeerClient, PlaycastWebrtcStats } from '@playcastdotio/Peer';
import React from 'react';
import ReactJson from 'react-json-view';

export const PeerStatsComponent = ({ clientPeer }: { clientPeer: PlaycastPeerClient }) => {
  // const [hostStats, setHostStats] = useState<PlaycastWebrtcStats | null>(null);
  const [remotePeerStats, setRemotePeerStats] = useState<{ [peerId: string]: PlaycastWebrtcStats | undefined }>({});

  useEffect(() => {
    // Get all current remote peer stats.
    const peerId = clientPeer.peerId;
    const stats = clientPeer.statistics.currentState;
    setRemotePeerStats((prev) => ({ ...prev, [peerId]: stats }));
    const clientPeerListener = clientPeer.statistics.addListener((newStats) => {
      setRemotePeerStats((prev) => ({ ...prev, [peerId]: newStats }));
    });

    return () => {
      clientPeer.statistics.removeListener(clientPeerListener);
    };
  }, [clientPeer]);

  return (
    <div>
      <ReactJson
        name={false}
        src={remotePeerStats}
        theme={'harmonic'}
        collapseStringsAfterLength={80}
        collapsed={1}
        indentWidth={2}
        style={{ fontSize: '16px', backgroundColor: 'rgba(0, 0, 0, 0)' }}
      />
    </div>
  );
};
